import { t } from "@lingui/core/macro";
import { DateTime } from "luxon";

import { SelectChangeEvent } from "@mui/material";

import Dropdown, {
  DropdownMenuItem,
  DropdownProps,
} from "@readai/common/components/Dropdown";
import { getLocalizedTimezones, getTimezoneName } from "@readai/common/utils";

interface TimezoneSelectorProps
  extends Omit<DropdownProps, "onChange" | "name"> {
  disableDefaultTimezone?: boolean;
  onChange: (timezone: string) => void;
  selected?: string | null;
}

const LOCAL_DATE = DateTime.local();
const DEFAULT_TIMEZONE = LOCAL_DATE.zone.name;

const TimezoneSelector = ({
  disableDefaultTimezone = false,
  onChange,
  selected,
  ...dropdownProps
}: TimezoneSelectorProps) => {
  const selectedValue =
    selected ?? (disableDefaultTimezone ? null : DEFAULT_TIMEZONE);

  const dropdownItems = getLocalizedTimezones();

  if (!selectedValue && !disableDefaultTimezone) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <Dropdown
      error={!selectedValue}
      {...dropdownProps}
      name="timezone-selector"
      onChange={handleChange}
      placeholder={t`Unspecified`}
      selectedItem={
        selectedValue
          ? {
              value: selectedValue,
              label: getTimezoneName(selectedValue),
            }
          : undefined
      }
    >
      {dropdownItems.map(({ value, label }) => (
        <DropdownMenuItem key={value} value={value} label={label} />
      ))}
    </Dropdown>
  );
};

export default TimezoneSelector;
